import type { Cell, Row } from 'write-excel-file/browser';

/** A sheet's rows plus the column widths sized to fit them. */
export interface SheetContent {
  /** Header row (bold) followed by the data rows. */
  rows: Row[];
  /** Column widths in characters, sized to the longest cell (clamped). */
  columns: { width: number }[];
}

const MIN_COLUMN_WIDTH = 8;
const MAX_COLUMN_WIDTH = 40;

export function headerCell(text: string): Cell {
  return { value: text, fontWeight: 'bold' };
}

/** Numbers/booleans/dates keep their type so Excel treats them as such; everything else is text. */
export function cell(value: unknown): Cell {
  if (value === null || value === undefined || value === '') return null;
  if (typeof value === 'number' || typeof value === 'boolean' || value instanceof Date)
    return value;
  return String(value);
}

function cellText(value: Cell): string {
  if (value === null || value === undefined) return '';
  if (typeof value === 'object' && !(value instanceof Date) && 'value' in value) {
    return cellText(value.value as Cell);
  }
  return String(value);
}

export function columnWidths(rows: Row[]): { width: number }[] {
  const count = rows[0]?.length ?? 0;
  return Array.from({ length: count }, (_, column) => {
    const longest = Math.max(0, ...rows.map((row) => cellText(row[column]).length));
    return { width: Math.min(MAX_COLUMN_WIDTH, Math.max(MIN_COLUMN_WIDTH, longest + 2)) };
  });
}
